<template>
  <div class=''>
      <Header :widthmun='windowWidth'/>

      <div class="new_box">
          <div class="container sp">
              <el-row>
                  <el-col :span="24">
                      <div class="col_list">
                          <el-breadcrumb separator="/">
                            <el-breadcrumb-item :to="{ path: '/' }">{{$t('home.home')}}</el-breadcrumb-item>
                            <el-breadcrumb-item>{{$t('rcname.title')}}</el-breadcrumb-item>
                            <el-breadcrumb-item>{{mename}}</el-breadcrumb-item>
                          </el-breadcrumb>
                      </div>
                      <h2 class="showtitle" v-html="mename"></h2>
                  </el-col>
              </el-row>
            
          </div>
      </div>

        <div class="content">
            <div class="container newcont">
                <el-row>
                    <el-col>
                        <div class="cont_box">

                            <el-row>

                                <el-col style="background: #fff;" v-if="windowWidth>=1024" class="el-col-box" :xs="24" :sm="24" :md="8" :lg="7" :xl="7" >
                                    <el-collapse v-model="activeName" accordion>
                                        <el-collapse-item :class="activeName=='1'?'activeheader':''" :title="$t('rcname.title1')" name="1">
                                            <div>
                                                <el-link :underline="false" :class="activeclass=='1'?'active':''" @click="changemenu($t('rcname.mename1'),'1')">{{$t('rcname.mename1')}}</el-link>
                                            </div>
                                        </el-collapse-item>
                                    </el-collapse>
                                </el-col>

                                <el-col style="background: #fff;" class="cont_box_col" v-show="parmaid == '1'" :xs="24" :sm="24" :md="15" :lg="16" :xl="16" >
                                   <div>
                                       <h3>{{$t('rcname.m1.c1')}}</h3>
                                       <p class="li_box"><i></i>{{$t('rcname.m1.c2')}}</p>
                                       <p class="li_box"><i></i>{{$t('rcname.m1.c3')}}</p>
                                       <el-row class="icon_box">
                                            <el-col :span="2">
                                                <img src="../../assets/img/issuers-icon.png" style="padding-right:20px" alt="">
                                            </el-col>
                                            <el-col :span="20" style="text-align:left">
                                                <p class="h5">{{$t('rcname.m1.c4')}}</p>
                                            </el-col>
                                        </el-row>
                                       <p class="li_box"><i></i>{{$t('rcname.m1.c5')}}</p>
                                       <p class="li_box"><i></i>{{$t('rcname.m1.c6')}}</p>
                                       <p class="li_box"><i></i>{{$t('rcname.m1.c7')}}</p>
                                       <p class="li_box"><i></i>{{$t('rcname.m1.c8')}}</p>
                                       <p class="li_box"><i></i>{{$t('rcname.m1.c9')}}</p>
                                       <el-row class="icon_box">
                                            <el-col :span="2">
                                                <img src="../../assets/img/investors-icon.png" style="padding-right:20px" alt="">
                                            </el-col>
                                            <el-col :span="20" style="text-align:left">
                                                <p class="h5">{{$t('rcname.m1.c10')}}</p>
                                            </el-col>
                                        </el-row>
                                       <p>{{$t('rcname.m1.c11')}}</p>
                                       <p>{{$t('rcname.m1.c12')}}</p>
                                       <p>{{$t('rcname.m1.c13')}}</p>

                                       <p class="li_box hp"><i></i>{{$t('rcname.m1.c14')}}</p>
                                       <p>{{$t('rcname.m1.c15')}}</p>
                                       <p class="li_box hp"><i></i>{{$t('rcname.m1.c16')}}</p>
                                       <p>{{$t('rcname.m1.c17')}}</p>
                                       <p class="li_box hp"><i></i>{{$t('rcname.m1.c18')}}</p>
                                       <p>{{$t('rcname.m1.c19')}}</p>
                                       <p class="li_box hp"><i></i>{{$t('rcname.m1.c20')}}</p>
                                       <p>{{$t('rcname.m1.c21')}}</p>
                                       <p class="li_box hp"><i></i>{{$t('rcname.m1.c22')}}</p>
                                       <p>{{$t('rcname.m1.c23')}}</p>
                                       <p class="li_box hp"><i></i>{{$t('rcname.m1.c24')}}</p>
                                       <p>{{$t('rcname.m1.c25')}}</p>
                                       <p class="li_box hp"><i></i>{{$t('rcname.m1.c26')}}</p>
                                       <p>{{$t('rcname.m1.c27')}}</p>
                                       <p class="li_box hp"><i></i>{{$t('rcname.m1.c28')}}</p>
                                       <p>{{$t('rcname.m1.c29')}}</p>
                                       <p class="li_box hp"><i></i>{{$t('rcname.m1.c30')}}</p>
                                       <p>{{$t('rcname.m1.c31')}}</p>
                                   </div>
                                 </el-col>
                                 
                            </el-row>

                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

      <Footer :widthmun='windowWidth'/>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Header from '@/components/Header/index.vue';
import Footer from '@/components/Footer/index.vue';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {Header,Footer},
  data () {
  // 这里存放数据
    return {
        parmaid:'',
        activeName: '1',
        mename:'',
        activeclass:'',
        windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
        windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
      windowHeight (val) {
        let that = this;
        
      },
      windowWidth (val) {
        let that = this;
        this.windowWidth = val
      }
  },
  // 方法集合
  methods: {
      changemenu(name,id){
          this.mename = '';
          this.mename = name;
          this.parmaid = id;
          this.activeclass = id;
      },
      changetype(){
          this.mename = '';
            if(this.parmaid == '1'){
                this.mename = this.$t('rcname.mename1')
                this.activeName = '1'
                this.changemenu(this.mename,this.parmaid)
            }
      }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
        this.parmaid = this.$route.query.id;
        this.$bus.$on('changeid', (id) =>{
            this.parmaid = id;
            this.changetype()
        })
        this.changetype()
        window.onresize = () => {
        return (() => {
            window.fullHeight = document.documentElement.clientHeight;
            window.fullWidth = document.documentElement.clientWidth;
            this.windowHeight = window.fullHeight;  // 高
            this.windowWidth = window.fullWidth; // 宽
        })()
    }
      
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.new_box{
    height:420px;
    background: url('../../assets/img/btcbj.png') no-repeat;
    background-size: cover;
    font-size:16px;
    color:#7d91aa;
}
::v-deep .el-breadcrumb__inner{
        color:#C8C8C8 !important;
        font-size:16px !important;
    }
.sp{
    padding-top:90px;
    padding-bottom:90px;
    .el-row{
        margin-top:10%;
    }
    .col_list{
        padding:10px;
        margin-bottom:20px;
    }
}
.showtitle {
    color: #fff!important;
    font-size:40px;
    line-height: 50px;
}

.span_box{
    font-weight:bold;
    color:#000;
}

.content{
    margin-top:-35px;
    min-height:700px;
    
    
    .cont_box{
        padding:20px;
        .el-row{
            margin-top:-20px;
        }
    }
    .h5{
        font-size:19px;
        font-family:inherit;
    }
    h6{
        font-size:14px;
        margin-bottom:25px;
        font-weight: normal;
    }
    p{
        margin-top:0;
        margin-bottom:16px;
        font-size:16px;
        line-height: 26px;
        
    }
    .new_box_list{
        padding-top:10px;
        padding-bottom:20px;
    }
}

.el-col-box{
    border:0.1px solid #fff;
    border-radius: 5px;
    margin-right:30px;
    box-shadow: 0px 5px 15px rgba(136,136,136,0.2);
}
::v-deep .el-collapse-item__header{
    padding-left:30px;
    font-weight:700;
    font-size:14px;
    color:#21212A;
    transition:all 0.4s ease;
    -webkit-transition:all 0.4s ease;
}
::v-deep .el-collapse-item__header:focus{
    background: #218CBA;
    color:#fff;
}
::v-deep .el-collapse-item__header:focus, .el-collapse, .el-col-box{
    border:none !important;
}
::v-deep .el-collapse-item__content{
    padding-left:30px;
    padding-top:10px;
    padding-bottom:10px;
    background: #EDEEF3;
    .el-link{
        font-size:12px;
        text-overflow: ellipsis;
        white-space: normal;
        line-height: 35px;
        transition:all 0.25s ease;
        -webkit-transition:all 0.25s ease;
        color:#5D5D5D;
        display: block;
    }
    .el-link:hover{
        color:#218CBA !important;
    }
    .active{
        color:#218CBA !important;
    }
}
::v-deep .activeheader{
    .el-collapse-item__header{
        background: #218CBA;
        color:#fff;
    }
}
.cont_box_col{
    transition:all 0.4s ease;
    -webkit-transition:all 0.4s ease;
    padding:30px 20px 20px 20px;
    h3{
        color:#218CBA!important;
        margin:28px 0;
        font-size:32px;
        line-height: 42px;
        font-family: Arial-BoldMT, Arial;
        letter-spacing:2px;
        padding:10px 0 10px 0;
        font-weight: normal;
    }
    .h5{
        color:#21212a !important;
        font-size:20px;
        line-height: 30px;
        padding-top:10px;
        padding-bottom:10px;
        font-weight: 800;
    }
    .h4{
        font-weight:800;
        font-family:"Roboto", sans-serif;
        font-size:18px;
        line-height: 28px;
    }
}
.icon_box{
    padding:30px 30px 30px 10px;
    p{
        padding-top:10px;
        padding-left:20px;
    }
}
.li_box{
    display: flex;
    i:after {
        content: url(../../assets/img/i1.png);
        margin-right: 9px;
    }
}
.color_p{
    color:#218CBA;
}
.hp{
    color:#21212A;
    font-weight:800;
    font-family:"Roboto", sans-serif;
    font-size:20px !important;
    line-height: 30px !important;
}
@media screen and (min-width: 280px) and (max-width: 1023px) {
    /deep/.el-collapse-item__header{
        font-size:24px !important;
        height: 80px;
    }
    /deep/.el-collapse-item__content .el-link{
        font-size:24px !important;
        line-height: 60px;
    }
    /deep/.el-collapse-item__content p{
        font-size:24px !important;
        line-height: 60px;
    }
}
</style>
